import { render, staticRenderFns } from "./html-iframe.vue?vue&type=template&id=c146c58a&scoped=true&"
import script from "./html-iframe.vue?vue&type=script&lang=js&"
export * from "./html-iframe.vue?vue&type=script&lang=js&"
import style0 from "./html-iframe.vue?vue&type=style&index=0&id=c146c58a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c146c58a",
  null
  
)

export default component.exports